import { render, staticRenderFns } from "./SettingsContentAssets.vue?vue&type=template&id=4ff774ec&lang=pug&"
import script from "./SettingsContentAssets.vue?vue&type=script&lang=js&"
export * from "./SettingsContentAssets.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContentAssets.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports